module.exports = __webpack_public_path__ + "static/media/verksomhetsutveckling.f165082a.png";